import { render, staticRenderFns } from "./RadioAttribute.vue?vue&type=template&id=cf6e18c2&scoped=true&"
import script from "./RadioAttribute.vue?vue&type=script&lang=js&"
export * from "./RadioAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6e18c2",
  null
  
)

export default component.exports